import { FC } from 'react'
import PageContainer from 'shared/components/PageContainer'
import PACKAGE from '../../package.json'

type Props = {
  error: string
}

const ErrorPage: FC<Props> = ({ error }) => {
  const handleReload = () => {
    window.location.reload()
  }

  return (
    <PageContainer version={PACKAGE.version}>
      <div className='flex flex-col items-center justify-center h-full text-white bg-[#1F2937]'>
        <p>An unexpected error occurred.</p>
        <p className='text-red-600 px-4 pt-2 text-center'>Error: {error}</p>
        <button
          onClick={handleReload}
          className='mt-4 px-4 py-2 bg-blue-500 text-white rounded'
        >
          Reload Page
        </button>
      </div>
    </PageContainer>
  )
}

export default ErrorPage
